import React, { Component } from 'react';

import { Col, Row, Button, Container, Table}  from 'react-bootstrap';

import {Rest} from "../../Helpers/Rest" 
import InfoBlock from "../../Components/InfoBlock/InfoBlock"
import PropTypes from 'prop-types';
import Uploads from "../../Components/Uploads/Uploads"
import Form from "../../Components/Form/Form"
var moment = require('moment'); // require

export default class Comments extends Component {
    state = { 
    }
    componentDidMount = () => {
      this.load()
    };

    load = () => {
        let rest = new Rest(this)
        rest.request('comments', 'GET', {record_id: this.props.record_id, table_name: this.props.table_name}, (res)=>{
            this.setState({
                comments: res
            })
        })
    }

    save = () =>{ 
        this.setState({
            errors: false,
            success: false
        })
        var data = this.state.data
        var rest = new Rest(this) 
        data['body'] = data['body_comment']
        data['table_name'] = this.props.table_name
        data['record_id'] = this.props.record_id.toString()
        if(this.state.uploads){
            data['uploads'] = this.state.uploads.map(u=>u.id)
        }
         

        rest.request("comments", "CREATE", data, (res)=>{ 
             if(!res.errors){
                 data.body_comment = ""
                 this.setState({
                     success: ["Added"],
                     data: data
                 })
                setTimeout(()=>location.reload(), 1000)
             }
        })

    }
    
    download = (f) => {
        let rest = new Rest(this)
        this.setState({
            ['loading_'+f.filename]: true
        })
        rest.get_file('uploads/'+f.id, {download: true}, f.filename, (res)=>{ 
            this.setState({
                ['loading_'+f.filename]: false
            })
        }) 
    }

    _render_as_file = (f)=>{
        return(
            <small>
                <div className="mt-2 bg-light"> 
                    <span className="mr-1">#{f.position}</span>
                    <span className="m-1 pointer text-primary" onClick={()=>this.download(f)}>{ this.state['loading_'+f.filename] ? "Downloading" : ""+f.filename } </span>
                </div>
            </small>
        )
    }


  render() {
      console.log(this.state)
    return (
    <div className="border p-3">
            {
                this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
            }
            {
                this.state.success && <InfoBlock data={this.state.success} variant="info" />
            }

        { !this.props.readonly &&  <Row className="mt-1 pt-2">
            <Col className="pb-3">
                <Form
                    fields = {[
                        {
                            name: "body_comment",
                            label: "Add comment:",
                            as: "textarea"
                        }, 
                    ]}
                    store_to={"data"}
                    _this = {this}
                />  
                <Uploads
                    label={"Add image, file"}
                    max={5}
                    table_name={"comments"}
                    variant="preview"
                    display_type="list" 
                    returnUploads={(uploads)=>this.setState({uploads:uploads})}
                />

                <Button className="btn-block" variant="info" onClick={this.save}>
                    Send
                </Button>
            </Col>
        </Row>}
        
        <Row className="mt-2">
            <Col>
                <h4>Comments</h4>
            </Col>
        </Row>

        <Row className="mt-1 mb-3">
            <Col>
                {this.state.comments && this.state.comments.length==0 &&
                    <span>No comments yet</span>
                }
                {this.state.comments && this.state.comments.length &&
                    this.state.comments.map(c=>{
                        return(
                            <Row key={c.id} className=" mt-1 border">
                                <Col xs={2} className="bg-light p-2 ">  
                                    <div>
                                        <small>
                                            <b>{c.username}</b>
                                        </small>
                                    </div>
                                    <div>
                                        <i>
                                            <small>{moment(c.created_at).format('YYYY-MM-DD HH:mm')}</small>
                                        </i>
                                    </div> 
                                </Col>
                                <Col className=""> 
                                    <small>
                                        {
                                            c.body.split("\n").map(line=>{
                                                return <div key={line}>{line}</div>
                                            })
                                        }
                                    </small> 
                                    {
                                        c.uploads.map(f=>{
                                            return this._render_as_file(f)
                                        })
                                    }
                                </Col>
                            </Row>
                        )
                    })
                }
            </Col>
        </Row>

    </div>
    );
  }
}

Comments.propTypes = {
    record_id: PropTypes.integer,
    table_name: PropTypes.string,
    readonly: PropTypes.bool,
}